import { Link } from '@tanstack/react-router';

import {
    buildRulesMarkdownPreview,
    stripRulesDocumentHeading,
} from '@apps/web/components/phoebe_chat_view/artifacts/update_playbook_artifacts';
import { type UpdatePlaybookArtifact } from '@apps/web/components/phoebe_chat_view/transcript_types';
import { Markdown } from '@apps/web/components/ui/markdown';

export function UpdatePlaybookArtifactCard({
    artifact,
}: {
    readonly artifact: UpdatePlaybookArtifact;
}) {
    const preview = artifact.updatedRulesMarkdown
        ? buildRulesMarkdownPreview(artifact.updatedRulesMarkdown) ||
          stripRulesDocumentHeading(artifact.updatedRulesMarkdown)
        : artifact.message || 'Open playbook';

    return (
        <div className="flex justify-start">
            <div className="w-full max-w-2xl space-y-2 break-words">
                <p className="text-foreground text-sm font-medium">
                    Updated Phoebe’s playbook
                </p>
                <Link
                    to="/playbooks"
                    title="Open playbook"
                    className="border-border/50 bg-card hover:border-border hover:bg-muted/20 block cursor-pointer rounded-xl border p-4 transition-colors"
                >
                    <Markdown className="text-sm leading-relaxed">
                        {preview}
                    </Markdown>
                </Link>
            </div>
        </div>
    );
}
